import setters from './setters';
import services from './services';

export default { ...setters, ...services };
